export const demo3 = {
    roomModelDmsId: '0136NQiaBLcX',
    startPosition: { x: 18.3, y: 2.84, z: -10 },
    directionOfView: { x: 0, y: 0, z: -0.001 },
    museumId: 12,
    about: {
        exhibition: {
            name: 'Amundsens interiørutstilling',
            description:
                'Hjemmet til Roald Amundsen står slik han forlot det da han forsvant i isødet i 1928. Historien om en av verdens fremste polarhelter sitter praktisk talt i veggene fortsatt. På Uranienborg får vi et inntrykk av privatpersonen Amundsen. Her er skrivebordet hans, det gamle pianoet som var med ombord på Maud og mange andre gjenstander, suvenirer og gaver som han hadde med tilbake fra ekspedisjonene og forskjellige foredragsturnéer.',
            url: 'https://beta.virtueltmuseum.no/exhibition/c67e15f2-344f-45e9-a351-858516f53640',
        },
        museum: {
            name: 'Museene i Akershus',
            url: 'https://beta.virtueltmuseum.no/museum/12',
        },
        imageUrl:
            'data:image/jpeg;base64,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',
    },
    dome: {
        skyBoxDmsId: '0136MvjisAqp',
    },
    lights: [
        {
            type: 'hemisphere',
            skyColor: '#DCDCDC',
            groundColor: '#A9A9A9',
            intensity: 0.3,
        },
        {
            type: 'spot',
            intensity: 0.8,
            position: [2.3, 4, -6.4],
            shadowBias: -0.015,
        },
        {
            type: 'spot',
            intensity: 0.8,
            position: [2.3, 4, -14.4],
            shadowBias: -0.015,
        },
        {
            type: 'spot',
            intensity: 0.8,
            position: [10.3, 4, -6.4],
            shadowBias: -0.015,
        },
        {
            type: 'spot',
            intensity: 0.8,
            position: [14.3, 4, -14.4],
            shadowBias: -0.015,
        },
    ],
    models: [
        {
            dmsId: '0136NRjSVVW7',
            position: { x: 9.58, y: 2.55, z: -7.99 },
            rotation: { x: 0, y: 1, z: 0 },
            scale: { x: 1.2, y: 1.2, z: 1.2 },
            viewerData: {
                model: {
                    type: 'Object',
                    dmsId: '0136NRjSVVW7',
                },
            },
        },
        {
            dmsId: '0136NRjSVVxT',
            position: { x: 14.89, y: 2.38, z: -14.37 },
            rotation: { x: 0, y: 0, z: 0 },
            scale: { x: 0.00015, y: 0.00015, z: 0.00015 },
            rotate: true,
            rotationAxis: 'y',
            viewerData: {
                model: {
                    type: 'Object',
                    dmsId: '0136NRjSVW7K',
                },
            },
        },
        {
            dmsId: '0136NRjSVpz4',
            position: { x: 3.26, y: 1.38, z: -7.14 },
            rotation: { x: 0, y: 3.15, z: 0},
            scale: { x: 2, y: 2, z: 2 },
            viewerData: {
                model: {
                    type: 'Object',
                    dmsId: '0136NRjSVpz4',
                },
            },
        },
        {
            dmsId: '0136NRjSVqDC',
            position: { x: 9.59, y: 2.2, z: -5.67 },
            rotation: { x: 0, y: 2.5, z: 0 },
            scale: { x: 2, y: 2, z: 2 },
            viewerData: {
                model: {
                    type: 'Object',
                    dmsId: '0136NRjSVqDC',
                },
                annotations: [
                    {
                        position: [0, 0.3, 0],
                        title: 'Annotasjon 1',
                        content: {
                            paragraphs: [
                                'Denne Adeliepingvinen ble fanget under Belgica-ekspedisjonen 1897-99 langs den Antarktiske halvøy. Det ble fanget mange pingviner under ekspedisjonen – både til mat og forskning.',
                                'Amundsen lærte seg å skrike på en måte som tiltrakk pingvinene. Som en kuriositet forsøkte han også å sette en pingvin som trekkdyr foran en slede, uten stor suksess.',
                                'Den utstoppede pingvinen mangler svømmehud mellom tærne og den har mistet høyre vinge, muligens i forbindelse med utstoppingen.',
                            ],
                        },
                        zoom: -0.3,
                    },
                    {
                        position: [0, 0, 0],
                        title: 'Annotasjon 2',
                        content: {
                            paragraphs: [
                                'Denne Adeliepingvinen ble fanget under Belgica-ekspedisjonen 1897-99 langs den Antarktiske halvøy. Det ble fanget mange pingviner under ekspedisjonen – både til mat og forskning.',
                                'Amundsen lærte seg å skrike på en måte som tiltrakk pingvinene. Som en kuriositet forsøkte han også å sette en pingvin som trekkdyr foran en slede, uten stor suksess.',
                                'Den utstoppede pingvinen mangler svømmehud mellom tærne og den har mistet høyre vinge, muligens i forbindelse med utstoppingen.',
                            ],
                        },
                        zoom: -0.3,
                    },
                    {
                        position: [0, 0.13, 0.04],
                        title: 'Annotasjon 3',
                        content: {
                            paragraphs: [
                                'Denne Adeliepingvinen ble fanget under Belgica-ekspedisjonen 1897-99 langs den Antarktiske halvøy. Det ble fanget mange pingviner under ekspedisjonen – både til mat og forskning.',
                                'Amundsen lærte seg å skrike på en måte som tiltrakk pingvinene. Som en kuriositet forsøkte han også å sette en pingvin som trekkdyr foran en slede, uten stor suksess.',
                                'Den utstoppede pingvinen mangler svømmehud mellom tærne og den har mistet høyre vinge, muligens i forbindelse med utstoppingen.',
                            ],
                        },
                        zoom: -0.5,
                    },
                ],
            },
            audio: {
                dmsId: '0136NvAQxgnZ',
                refDistance: 0.5,
                rolloffFactor: 1,
                volume: 0.3,
                loop: true,
                maxDistance: 3,
            },
        },
        {
            dmsId: '0136NRjTvnvv',
            position: { x: 1.93, y: 1.724, z: -3.06 },
            rotation: { x: 0, y: 0.85, z: -1.55 },
            scale: { x: 2, y: 2, z: 2 },
            viewerData: {
                model: {
                    type: 'Object',
                    dmsId: '0136NRjTvnvv',
                },
            },
        },
    ],
    images: [
        {
            dmsId: '022sAXjSy8H9',
            scale: 9.6,
            rotation: { x: 0, y: Math.PI / 2, z: 0 },
            position: { x: 0.34, y: 1.95, z: -5.25 },
        },
        {
            dmsId: '0136MvjoHSu5',
            scale: 4.305,
            rotation: { x: 0, y: 0, z: 0 },
            position: { x: 18.18, y: 2.3, z: -15.42 },
        },
        {
            dmsId: '022sAXqmBRGa',
            scale: 9.6,
            rotation: { x: 0, y: Math.PI / 2, z: 0 },
            position: { x: 0.34, y: 1.7, z: -15.45 },
        },
        {
            dmsId: '032sAXjRXqJg',
            scale: 5.2,
            rotation: { x: 0, y: -Math.PI / 2, z: 0 },
            position: { x: 16.58, y: 1.95, z: -18.02 },
        },
        {
            dmsId: '012uKXR6YctP',
            scale: 4.734,
            rotation: { x: 0, y: Math.PI / 2, z: 0 },
            position: { x: 16.57, y: 2, z: -8.25 },
        },
    ],
    videos: [
        {
            dmsId: '012uPXGEtNxY',
            width: 1,
            height: 0.6,
            position: { x: 12.8, y: 3.66, z: -10.34 },
            rotation: { x: 1.475, y: 1.165, z: -1.505 },
            autoPlay: false,
        },
    ],
    texts: [
        {
            position: { x: 19.78, y: 2.6, z: -13.5 },
            rotation: { x: 0, y: -Math.PI / 2, z: 0 },
            color: '#171717',
            maxWidth: 2,
            paragraphs: [
                {
                    text: 'Amundsens interiør',
                    fontSize: 0.37,
                },
                {
                    text: 'Roald Amundsen forsvant i isødet i 1928. Gjenstandene han etterlot seg hjemme gir et inntrykk av privatpersonen Amundsen. Her kan du se gjenstander, suvenirer og gaver som han hadde med seg tilbake fra ekspedisjonene og forskjellige foredragsturnéer.',
                    fontSize: 0.1,
                    lineHeight: 1.35,
                    margin: {
                        top: 0.05,
                        bottom: 0.1,
                    },
                },
                {
                    text: 'Museene i Akershus',
                    fontSize: 0.04,
                },
                {
                    text: 'mia.no',
                    fontSize: 0.04,
                },
            ],
        },
    ],
    quizzes: [
        {
            position: { x: 11.7, y: 1.4, z: -18.7 },
            scale: { x: 1.4, y: 1.4, z: 1.4 },
            content: {
                title: 'Test Quiz',
                questions: [
                    {
                        id: 1,
                        question:
                            'Hva het polarskipet Amundsen benyttet i ekspedisjonen til Sydpolen?',
                        a: 'Gjøa',
                        b: 'Kon-Tiki',
                        c: 'Fram',
                        d: 'DFDS Seaways',
                        answer: 'c',
                    },
                    {
                        id: 2,
                        question: 'Hvilken art er den største pingvinen?',
                        a: 'Kongepingvin',
                        b: 'Keiserpingvin',
                        c: 'Hornpingvin',
                        d: 'Langduskpingvin',
                        answer: 'b',
                    },
                    {
                        id: 3,
                        question:
                            'Hva het konkurrenten til Amundsen som tapte kappløpet og døde på Sydpolen?',
                        a: 'Adrien de Gerlache',
                        b: 'Robert F. Scott',
                        c: 'Ernest Henry Shackleton',
                        d: 'Lincoln Ellsworth',
                        answer: 'b',
                    },
                ],
            },
        },
    ],
}